module.exports = __webpack_public_path__ + "37bc48228cf4cc781d8379cbd2b8810e.pdf";